import React, { useState } from 'react'
import { usePurchaseOrdersSourceSummary } from '../../hooks/queries/sourceSummary'
import SourceAccordians from './components/SourceAccordian/SourceAccordians'
import PurchaseOrdersSourceData from './sections/PurchaseOrdersSourceData'
import { useQueryClient } from 'react-query'
import Loading from '../../components/Loading'
import { useAuth0 } from '@auth0/auth0-react'
import AllPurchaseOrdersTable from './components/AllPurchaseOrdersTable'
import { useAllPurchaseOrders } from '../../hooks/queries/allPurchaseOrders'

export default function PurchaseOrdersPage() {
  const [sheetData, setSheetData] = useState({})
  const [expanded, setExpanded] = useState(false)

  const sourceSummaryType = 'purchaseOrderSummary'
  const sourceSummaryQueryKey = 'purchaseOrderSourceSummary'
  const dataSummaryQueryKey = 'purchaseOrderTable'
  const pageDataType = 'purchaseOrders'

  const { user } = useAuth0()

  const { isFetching: iFSourceData } = usePurchaseOrdersSourceSummary(sourceSummaryQueryKey, sourceSummaryType, {
    setSheetData,
  })

  const {
    isLoading: iLTableData,
    isErroxr: iETableData,
    isFetching: iFTableData,
    data: purchaseOrderTableData,
  } = useAllPurchaseOrders(dataSummaryQueryKey, 1000, 0, user?.email)

  const queryClient = useQueryClient()
  const refetchData = () => {
    queryClient.refetchQueries([sourceSummaryQueryKey])
    queryClient.refetchQueries([dataSummaryQueryKey])
  }

  const refreshTableData = () => {
    queryClient.refetchQueries([dataSummaryQueryKey])
  }

  const setExpand = (val) => {
    setExpanded(val)
  }

  const sourceDataSources = iFSourceData
    ? []
    : [<PurchaseOrdersSourceData refetchData={refetchData} uploadSummary={sheetData} key={0} setExpand={setExpand} />]

  const clearSheetData = () => {
    setSheetData({})
  }

  const tableData = iLTableData || iETableData || iFTableData ? [] : purchaseOrderTableData

  return (
    <>
      {iFSourceData ? (
        <Loading />
      ) : (
        <SourceAccordians
          label={'Purchase Order'}
          sources={sourceDataSources}
          refetchData={refetchData}
          clearSheetData={clearSheetData}
          displayComp={<AllPurchaseOrdersTable data={tableData} refreshTableData={refreshTableData} />}
          sourceSummaryQueryKey={sourceSummaryQueryKey}
          dataSummaryQueryKey={dataSummaryQueryKey}
          pageDataType={pageDataType}
          toExpand={expanded}
        />
      )}
    </>
  )
}
